module.exports = __webpack_public_path__ + "static/img/qq_5.6a827ad5.png";